/* eslint-disable @tencent/i18next/no-literal-string */
import { isIPhone, isAndroid } from './model-pb/utils/device';

/**
 * 腾讯文档内置格式码表
 */
export const BUILDIN_FORMAT_CODE: {[id: number]: string} = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    5: '\\¥#,##0;\\¥-#,##0',
    6: '\\¥#,##0;]\\¥-#,##0',
    7: '\\¥#,##0.00;\\¥-#,##0.00',
    8: '\\¥#,##0.00;]\\¥-#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'yyyy/m/d',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h: mm AM/PM',
    19: 'h: mm: ss AM/PM',
    20: 'h: mm',
    21: 'hh: mm: ss',
    22: 'yyyy/m/d h: mm',
    23: '\\$#,##0_);(\\$#,##0)',
    24: '\\$#,##0_);](\\$#,##0)',
    25: '\\$#,##0.00_);(\\$#,##0.00)',
    26: '\\$#,##0.00_);](\\$#,##0.00)',
    27: 'yyyy"年"m"月"',
    28: 'm"月"d"日"',
    29: 'm"月"d"日"',
    30: 'm/d/yy',
    31: 'yyyy"年"m"月"d"日"',
    32: 'h"时"mm"分"',
    33: 'h"时"mm"分"ss"秒"',
    34: '上午/下午h"时"mm"分"',
    35: '上午/下午h"时"mm"分"ss"秒"',
    36: 'yyyy"年"m"月"',
    37: '#,##0;-#,##0',
    38: '#,##0;]-#,##0',
    39: '#,##0.00;-#,##0.00',
    40: '#,##0.00;]-#,##0.00',
    41: '_ * #,##0_ ;_ * -#,##0_ ;_ * "-"_ ;_ @_ ',
    42: '_ \\¥* #,##0_ ;_ \\¥* -#,##0_ ;_ \\¥* "-"_ ;_ @_ ',
    43: '_ * #,##0.00_ ;_ * -#,##0.00_ ;_ * "-"??_ ;_ @_ ',
    44: '_ \\¥* #,##0.00_ ;_ \\¥* -#,##0.00_ ;_ \\¥* "-"??_ ;_ @_ ',
    45: 'mm: ss',
    46: 'mm: ss: ',   // 示从1900-1-0日开始到数值代表时间的小时数
    47: 'mm: ss.0',
    48: '##0.0E+0',
    49: '@',
    50: 'yyyy"年"m"月"',
    51: 'm"月"d"日"',
    52: 'yyyy"年"m"月"',
    53: 'm"月"d"日"',
    54: 'm"月"d"日"',
    55: '上午/下午h"时"mm"分"',
    56: '上午/下午h"时"mm"分"ss"秒"',
    57: 'yyyy"年"m"月"',
    58: 'm"月"d"日"',
    59: '0',
    60: '0.00',
    61: '#,##0',
    62: '#,##0.00',
    63: '\\¥#,##0;\\¥-#,##0',
    64: '\\¥#,##0;]\\¥-#,##0',
    65: '\\¥#,##0.00;\\¥-#,##0.00',
    66: '\\¥#,##0.00;]\\¥-#,##0.00',
    67: '0%',
    68: '0.00%',
    69: '# ?/?',
    70: '# ??/??',
    71: 'yyyy/m/d',
    72: 'yyyy/m/d',
    73: 'd-mmm-yy',
    74: 'd-mmm',
    75: 'mmm-yy',
    76: 'h: mm',
    77: 'h: mm: ss',
    78: 'yyyy/m/d h: mm',
    79: 'mm: ss',
    80: 'mm: ss',
    81: 'mm: ss.0',
};

/**
 * 表格默认的格式码
 */
export const DEFAULT_NUMBER_FORMAT_CODE = BUILDIN_FORMAT_CODE[0];

/**
 * 文档部分格式字段对应微软 office 数字格式的映射
 * 注意:
 *  - 这里是控制：手动设置单元格格式的时候，选择的格式串，要跟输入自动识别的格式串区分开
 *  - pc端比移动端少了一些格式串
 */
export const TXSHEET2MSO_FORMATCODE_MAPPING = ((): {[key: string]: string} => {
    if (isIPhone() || isAndroid()) {
        return {
            auto: 'General',
            default: 'General',
            text: '@',    // 纯文本
            numeral: '#,##0.00_ ',    // 数字
            percentage: '0.00%',    // 百分比
            'percentage-int': '0%',    // 百分比
            exponential: '0.00E+00',    // 科学计数法
            'currency-chs': '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',    // 人民币
            'currency-hk': '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
            'currency-en': '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',    // 美元
            time: 'h:mm:ss;@',    // 时间 11:33:34
            'date-time': 'yyyy/m/d h:mm:ss;@',    // 时间日期 2016/12/12 11:33:34
            date: 'yyyy/m/d',    // 短时间 2016/12/12
            'date-chs': 'yyyy"年"m"月"d"日";@',    // 长日期 2016年12月12日
            'date-chs-ym': 'yyyy"年"m"月";@',
            'date-chs-md': 'm"月"d"日";@',
            fraction: '# ?/?',
            m_d_yy: 'm/d/yy;@',
            'mmm-yy': '[$-409]mmm-yy;@',
            m_d: 'm/d;@',
            'yyyy-mm-dd': 'yyyy-mm-dd;@',
            yyyy_mm_dd: 'yyyy/mm/dd;@',
            'yyyy_m_d-h-m': 'yyyy/m/d h:mm;@',
            'h-mm': 'h:mm;@',
            yy_m_d: 'yy/m/d;@',
            'h-mm-ss-am_pm': '[$-409]h:mm:ss\\ AM/PM;@',
        };
    }
    return {
        default: 'General',
        auto: 'General',
        text: '@',    // 纯文本
        numeral: '#,##0.00_ ',    // 数字
        percentage: '0.00%',    // 百分比
        'percentage-int': '0%',    // 百分比
        exponential: '0.00E+00',    // 科学计数法
        currency: '#,##0.00',
        'currency-chs': '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',    // 人民币
        'currency-hk': '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
        'currency-en': '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',    // 美元
        time: 'h:mm:ss;@',    // 时间 11:33:34
        'date-time': 'yyyy/m/d h:mm:ss',    // 时间日期 2016/12/12 11:33:34
        date: 'yyyy/m/d',    // 短时间 2016/12/12
        accounting: '_ * #,##0.00_ ;_ * -#,##0.00_ ;_ * "-"??_ ;_ @_',    // 千位分隔符
        'date-chs': 'yyyy"年"m"月"d"日";@',    // 长日期 2016年12月12日
        'date-chs-ym': 'yyyy"年"m"月";@',
        'date-chs-md': 'm"月"d"日";@',
        fraction: '# ?/?',
    };
})();

/**
 * 文档部分格式字段对应微软 office 数字类型映射
 * 即上面的对象的逆过来
 */
export const TXSHEET2MSO_FORMATTYPE_MAPPING = Object.keys(TXSHEET2MSO_FORMATCODE_MAPPING)
    .reduce((newObj: any, key) => {
        newObj[TXSHEET2MSO_FORMATCODE_MAPPING[key]] = key;
        return newObj;
    }, {});
